import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: localStorage.getItem("langId") || "AM", // Default language
  translations: {}, // Object to store translations
  isLogedIn: false,
  fuelTypes: [],
  userData: JSON.parse(localStorage.getItem("userData")) || {},
};

const appSlice = createSlice({
  // name: "language",
  name: "app",
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setTranslations(state, action) {
      state.translations = action.payload;
    },
    setLoginState(state, action) {
      state.isLogedIn = action.payload;
    },
    setFuelTypes(state, action) {
      state.fuelTypes = action.payload;
    },
    setUserData(state, action) {
      state.userData = action.payload;
    },
  },
});

export const {
  setLanguage,
  setTranslations,
  setLoginState,
  setFuelTypes,
  setUserData,
} = appSlice.actions;
export default appSlice.reducer;
